/* -------------------------------------------------------------------------- */
/*                               Spinner styles                               */
/* -------------------------------------------------------------------------- */
@import './bq-spinner.variables';

:host {
  @apply relative inline-block;
}

.bq-spinner {
  @apply flex;
}

/* -------------------------------------------------------------------------- */
/*                             Spinner loader size                            */
/* -------------------------------------------------------------------------- */

.bq-spinner--loader.large {
  @apply bs-[--bq-spinner--size-large] is-[--bq-spinner--size-large];
}

.bq-spinner--loader.medium {
  @apply bs-[--bq-spinner--size-medium] is-[--bq-spinner--size-medium];
}

.bq-spinner--loader.small {
  @apply bs-[--bq-spinner--size-small] is-[--bq-spinner--size-small];
}

/* -------------------------------------------------------------------------- */
/*                                Text position                               */
/* -------------------------------------------------------------------------- */

.text-left,
.text-right {
  @apply flex-row items-center;

  &.has-text {
    @apply gap-x-m;
  }
}

.text-left {
  .bq-spinner--loader,
  .bq-spinner--icon {
    @apply order-2;
  }

  .bq-spinner--text {
    @apply order-1;
  }
}

.text-right {
  .bq-spinner--loader,
  .bq-spinner--icon {
    @apply order-1;
  }

  .bq-spinner--text {
    @apply order-2;
  }
}

.text-above,
.text-below {
  @apply flex-col items-center;

  &.has-text {
    @apply gap-y-m;
  }
}

.text-above {
  .bq-spinner--loader,
  .bq-spinner--icon {
    @apply order-2;
  }

  .bq-spinner--text {
    @apply order-1;
  }
}

.text-below {
  .bq-spinner--loader,
  .bq-spinner--icon {
    @apply order-1;
  }

  .bq-spinner--text {
    @apply order-2;
  }
}

/* -------------------------------------------------------------------------- */
/*                      Animate slotted icon if provided                      */
/* -------------------------------------------------------------------------- */

.is-animated {
  .bq-spinner--icon,
  .bq-spinner--loader > svg {
    @include animation-spin;
  }
}
